import { ReactElement } from 'react';
import { baseClass } from './CreateAccount';
import { FormFeedback, FormGroup } from '../../components';
import { InputGroupProps } from './InputField';

export const PasswordFields = ({ register, errors }: InputGroupProps): ReactElement => {
  return (
    <>
      <FormGroup className={`${baseClass}__form-group`}>
        <label htmlFor="password">
          <span className={`${baseClass}__label`}>Password</span>
          <input
            {...register('password')}
            className={`${baseClass}__input vol-input`}
            name="password"
            maxLength={30}
            type="password"
            autoComplete="off"
            data-testid="passwordInput"
          />
        </label>
        <FormFeedback className={`${baseClass}__feedback`}>
          {errors?.password?.message}
        </FormFeedback>
      </FormGroup>
      <FormGroup className={`${baseClass}__form-group`}>
        <label htmlFor="confirmPassword">
          <span className={`${baseClass}__label`}>Confirm Password</span>
          <input
            {...register('confirmPassword')}
            className={`${baseClass}__input vol-input`}
            maxLength={30}
            type="password"
            autoComplete="off"
            data-testid="confirmPasswordInput"
          />
        </label>

        <FormFeedback className={`${baseClass}__feedback`}>
          {errors?.confirmPassword?.message}
        </FormFeedback>
      </FormGroup>
    </>
  );
};

export default PasswordFields;
